/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Not_SyncedInputs */

const en_admin_funnel_history_not_synced = /** @type {(inputs: Admin_Funnel_History_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No traffic imported yet. Run \`npx tsx scripts/sync-traffic.ts\`.`)
};

/**
* | output |
* | --- |
* | "No traffic imported yet. Run `npx tsx scripts/sync-traffic.ts`." |
*
* @param {Admin_Funnel_History_Not_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_not_synced = /** @type {((inputs?: Admin_Funnel_History_Not_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Not_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_not_synced(inputs)
});
export { admin_funnel_history_not_synced as "admin.funnel.history.not_synced" }